import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from '@/components/ConfirmDialog';
import { useLogout } from '@/hooks/useLogout';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const LogoutConfirmDialog: React.FC<Props> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const logout = useLogout();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const confirmLogout = async () => {
    setIsLoggingOut(true);
    await logout();
  };

  return (
    <ConfirmDialog
      isOpen={isOpen}
      title={t('global.logoutConfirm')}
      confirmLabel={t('global.logout')}
      isPending={isLoggingOut}
      onClose={onClose}
      onConfirm={confirmLogout}
    />
  );
};
